import {Controller} from "stimulus"
import {TimelineLite} from "gsap/TimelineLite"
import {TweenLite} from "gsap/TweenLite"

/**
 * Form bone de recharge
 */
export default class extends Controller {

    static targets = [
    ]

    initialize() {
        console.log("switch")
    }

    click(e){
        e.preventDefault();

        let firstParent = e.currentTarget.parentNode;
        let isActive = firstParent.querySelector(".switch-el.is-active");
        isActive.classList.remove("is-active");

        let that = e.currentTarget;
        that.classList.add("is-active");

        let containBefore = that.classList.contains("before");
        let parent = e.currentTarget.parentNode.parentNode;
        if(containBefore){
            parent.classList.add("before");
        }else{
            parent.classList.remove("before");
        }

    }



}
